import React, { useContext } from 'react'
import BuffetContainer from 'components/buffet/BuffetContainer'
import { AppContext } from 'contexts/AppProvider'
import { useSelector } from 'react-redux'
import { buffetSelector } from 'store/slices/buffetSlice'
import PromotionController from './PromotionController'

const PromotionContainer = () => {
  const { brand } = useContext(AppContext)
  const buffet = useSelector(buffetSelector)
  const isReady = Number(brand?.id) && buffet.table.orderID && buffet.table.tableID

  return <BuffetContainer>{isReady && <PromotionController />}</BuffetContainer>
}

export default PromotionContainer
